<template>
  <div ref="chartContainer" style="width: 100%;height: 100%;"></div>
</template>

<script setup>
import * as echarts from 'echarts';
import { ref, onMounted, reactive,onUnmounted } from 'vue';
const chartContainer = ref(null); 
const chartData = [
  {
      "sf": "山东",
      "jwd": " 117.1582, 36.8701",
      "sl": 360570.0
    },
    {
      "sf": "安徽",
      "jwd": " 117.29, 32.0581",
      "sl": 358122.0
    },
    {
      "sf": "湖北",
      "jwd": " 114.3896, 30.6628",
      "sl": 132600.0
    },
    {
      "sf": "浙江",
      "jwd": " 119.5313, 29.8773",
      "sl": 48000.0
    },
    {
      "sf": "广东",
      "jwd": " 113.12244, 23.009505",
      "sl": 31110.0
    },
    {
      "sf": "辽宁",
      "jwd": " 123.1238, 42.1216",
      "sl": 30500.0
    },
    {
      "sf": "四川",
      "jwd": " 103.9526, 30.7617",
      "sl": 24684.0
    },
    {
      "sf": "福建",
      "jwd": " 119.4543, 25.9222",
      "sl": 21063.0
    },
    {
      "sf": "黑龙江",
      "jwd": "127.9688, 45.368",
      "sl": 17500.0
    },
    {
      "sf": "西藏",
      "jwd": " 91.117212,29.646922",
      "sl": 6120.0
    },
    {
      "sf": "江西",
      "jwd": " 116.0046, 28.6633",
      "sl": 5100.0
    },
    {
      "sf": "广西",
      "jwd": " 108.479, 23.1152",
      "sl": 5100.0
    },
    {
      "sf": "河南",
      "jwd": "114.26825,33.26825",
      "sl": 5000.0
    },
    {
      "sf": "青海",
      "jwd": " 101.4038, 36.8207",
      "sl": 1020.0
    }
];

// 初始化地理坐标映射和GZData
const geoCoordMap = reactive({});
// const GZData = reactive([]);
const GZConnections = reactive([]);

chartData.forEach(item => {
  const [lng, lat] = item.jwd.split(',').map(Number);
  geoCoordMap[item.sf] = [lng, lat];
  GZConnections.push({ fromName: '河南', toName: item.sf, value: 90 });
});


geoCoordMap['上蔡'] = [114.26825,33.26825];

const convertData = (data) => {
  var res = [];
  for (var i = 0; i < data.length; i++) {
    var dataItem = data[i];
    if (geoCoordMap[dataItem.fromName] && geoCoordMap[dataItem.toName]) {
      res.push({
        fromName: dataItem.fromName,
        toName: dataItem.toName,
        coords: [geoCoordMap[dataItem.fromName], geoCoordMap[dataItem.toName]]
      });
    }
  }
  return res;
};

const series = reactive([]);

[['上蔡', GZConnections]].forEach(([province, data]) => {
  series.push(
    {
      name: `${province} Top10`,
      type: 'lines',
      zlevel: 1,
      symbol: ['circle', 'circle'],
      symbolSize: 10,
      effect: {
        show: true,
        period: 3,
        trailLength: 0.3,
        symbol: 'arrow',
        symbolSize: 5,
      },
      lineStyle: {
        normal: {
          color: function (params) {
            const colorList = ["#F64347", "#04CF68", "#04B4F6", "#E9CC08", "#FB9E19"];
            return colorList[params.dataIndex % colorList.length];
          },
          width: 2,
          opacity: 0.7,
          curveness: -0.2,
        },
      },
      data: convertData(data),
    },
    {
      name: `${province} Top10`,
      type: 'effectScatter',
      coordinateSystem: 'geo',
      zlevel: 1,
      rippleEffect: {
        brushType: 'stroke',
        period: 4,
        scale: 4,
      },
      label: {
        normal: {
          show: false,
          position: 'right',
          formatter: '{b}',
          textStyle: {
            fontSize: 14,
            color: '#fff'
          }
        }
      },
      symbol: 'none',
      data: data.map((item) => ({
        name: item.toName,
        value:geoCoordMap[item.toName]
      })),
    }
  );
});

const option = reactive({
  geo: {
    map: 'china',
    aspectScale: 0.88,
    layoutCenter: ["50%", "50%"],
    layoutSize: '70%',
    zoom: 1.5,
    // roam: true,
    scaleLimit: {
      min: 1,
      max: 2
    },
    label: {
      show: true,
      color: '#C6F5FE',
      fontSize: 12,
    },
    itemStyle: {
      normal: {
        areaColor: "RGBA(17, 75, 94, 1)",
        borderColor: "rgba(152, 234, 255, 1)",
        borderWidth: 0.5,
        shadowColor: 'rgba(59,202,251,0.5)',
        shadowOffsetX: 6,
        shadowOffsetY: 12,
        shadowBlur: 6,
      },
      emphasis: {
        areaColor: 'RGBA(7, 62, 86, 1)',
        label: {
          color: "#fff"
        }
      }
    },
    regions: [
      {
        name: '南海诸岛',
        itemStyle: {
          areaColor: 'rgba(0, 10, 52, 1)',
          borderColor: 'rgba(0, 10, 52, 1)',
          normal: {
            opacity: 0,
            label: {
              show: false,
              color: "#009cc9",
            }
          },
        },
        label: {
          show: false
        }
      }
    ],
  },
  series: series
});

let chartInstance;

onMounted(() => {
  // 获取chartContainer的DOM元素
  // const chartContainerElement = ref('chartContainer').value;
const containerElement = chartContainer.value;
  // chartInstance = echarts.init(chartContainerElement);
  chartInstance = echarts.init(containerElement, null, {
    // width: '100%', // 设置宽度适应容器大小
    // height: '100%',
  });

  chartInstance.setOption(option);
  
  // 可以在此处添加更多交互逻辑或事件监听
});

onUnmounted(() => {
  if (chartInstance && chartInstance.dispose) {
    chartInstance.dispose();
  }
});
</script>